import { render, staticRenderFns } from "./UMLVOEmail.vue?vue&type=template&id=01c6d3e6&scoped=true&"
import script from "./UMLVOEmail.vue?vue&type=script&lang=js&"
export * from "./UMLVOEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6d3e6",
  null
  
)

export default component.exports